module.exports = __webpack_public_path__ + "assets/img/btn-view-de4b7422.png";